// extracted by mini-css-extract-plugin
module.exports = {"customFormItem":"mergeForm_customFormItem__1x4uh"};